import BronzeMatteTrophy from '@/assets/bronze_matte_trophy.svg'
import BronzeMedal from '@/assets/bronze_medal.svg'
import BronzeTrophy from '@/assets/bronze_trophy.svg'
import GoldMatteTrophy from '@/assets/gold_matte_trophy.svg'
import GoldMedal from '@/assets/gold_medal.svg'
import GoldTrophy from '@/assets/gold_trophy.svg'
import SilverMatteTrophy from '@/assets/silver_matte_trophy.svg'
import SilverMedal from '@/assets/silver_medal.svg'
import SilverTrophy from '@/assets/silver_trophy.svg'
import Stamp from '@/assets/stamp.svg'

export const MAX_RECORD_DAYS = 5
export const ONE_MINUTE = 60 * 1000
export const ONE_HOUR = 60 * ONE_MINUTE
export const ONE_DAY = 24 * ONE_HOUR

export const QUEST_TYPE_SNS_FOLLOW = 1
export const QUEST_TYPE_INVITE = 2
export const QUEST_TYPE_APP_DOWNLOAD = 3
export const QUEST_TYPE_APP_JOIN = 4
export const QUEST_TYPE_LUCKY_DRAW = 5
export const QUEST_TYPE_RANK_INVITE = 102

export const SHOW_RANKING_SIZE = 3
export const HOT_EVENT_CONDITION = 300
export const MEDAL_ASSETS = [GoldMedal, SilverMedal, BronzeMedal]
export const TROPHY_ASSETS = [GoldTrophy, SilverTrophy, BronzeTrophy]
export const MATTE_TROPHY_ASSETS = [
  GoldMatteTrophy,
  SilverMatteTrophy,
  BronzeMatteTrophy,
]
export const STAMP_ASSETS = [Stamp]

export const STATUS_LABEL = {
  COMPLETED: 'completed',
  HOT: 'hot',
  OUT: 'out',
  END: 'end',
}

export const QUEST_STATUS = {
  NONE: 0,
  COMPLETE: 1,
}
